(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-switch"] && !Shopify.designMode) return;
  try {
    (function () {
  var LEVELS = ['fit-0', 'fit-1', 'fit-2', 'fit-3', 'fit-4', 'fit-5'];
  function init() {
    var row = document.querySelector('.hdr .row');
    var icons = row && row.querySelector('.icons');
    if (!row || !icons || row.__fit) return;
    row.__fit = true;
    /* too wide = the icons (cart, language) run past the row's content edge (into its side padding), or closer
       than 12 px to the screen's edge */
    var over = function () {
      var r = icons.getBoundingClientRect().right;
      var edge = row.getBoundingClientRect().right - (parseFloat(getComputedStyle(row).paddingRight) || 0);
      return r > edge + 2 || r > document.documentElement.clientWidth - 12;
    };
    var fit = function () {
      LEVELS.forEach(function (c) { row.classList.remove(c); });
      if (window.innerWidth < 900) return;
      for (var i = 0; i < LEVELS.length && over(); i++) row.classList.add(LEVELS[i]);
    };
    var t;
    fit();
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 100); });
    window.addEventListener('load', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    document.addEventListener('shopify:section:load', function () { var r = document.querySelector('.hdr .row'); if (r && !r.__fit) init(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

})();
